interface UserDetailsProps {
	name: string;
	age: string;
	gender: string;
	email: string;
	phone: string;
	ratings: { double: string; single: string };
}

export function UserDetails({ name, age, gender, email, phone, ratings }: UserDetailsProps) {
	return (
		<div className="flex grow flex-col items-center sm:pl-6 sm:items-start">
			<div className=" items-center">
				<h3 className="inline text-sm font-semibold leading-6 text-gray-900">
					<p className="inline-block">{name}</p>
				</h3>

				<div className="flex items-center justify-center space-x-2 text-gray-900 sm:justify-start">
					<p className="text-xs leading-[18px]">Age: {age}</p>
					<p className="text-xs leading-[18px]">|</p>
					<p className="text-xs leading-[18px]">{gender}</p>
				</div>
			</div>
			<p className="pt-1 text-xs leading-[18px] text-gray-900">{email}</p>
			<p className="pt-1 text-xs leading-[18px] text-gray-900">{phone}</p>
			<div className="flex pt-2 text-xs leading-[18px]">
				<p className="mr-4 text-gray-900">(D) {ratings.double}</p>
				<p className="text-gray-500">(S) {ratings.single}</p>
			</div>
		</div>
	);
}
